import { useEffect } from 'react'
import useGetZendeskToken from '@/pages/hooks/use-get-zendesk-token'

const useZendesk = () => {
  const { data, error } = useGetZendeskToken()
  useEffect(() => {
    const scriptId = 'ze-snippet'
    const apiKey = import.meta.env.VITE_ZENDESK_KEY
    const scriptSrc = `https://static.zdassets.com/ekr/snippet.js?key=${apiKey}`

    // Function to load the Zendesk widget script
    const loadZendeskWidget = () => {
      if (document.getElementById(scriptId)) return

      const script = document.createElement('script')
      script.id = scriptId
      script.src = scriptSrc

      // Error handling for script loading
      script.onerror = () => {
        console.error('Failed to load the Zendesk widget script.')
      }

      document.body.appendChild(script)
      script.addEventListener('load', async () => {
        try {
          if (window.zE && data?.token) {
            window.zE('messenger', 'loginUser', cb => cb(data?.token))
          }
        } catch (e) {
          console.error(`Could not fetch zendesk access token`, e)
        }
      })
    }

    // Function to remove the Zendesk widget script
    const removeZendeskWidget = () => {
      const script = document.getElementById(scriptId)
      if (script) {
        script.remove()
        if (window.zE) window.zE('messenger', 'close')
      }
    }

    // Load widget the if token exist otherwise wait for the error and load the widget without token verification
    if (data?.token || error) loadZendeskWidget()

    // Cleanup widget on component unmount
    return () => removeZendeskWidget()
  }, [data, error])
}

export default useZendesk
